import React, { useEffect, useState } from "react";
import divider from "../../assets/bg/divider.png";
import DetectDevice from "../../data/DetectDevice";
import mouse from "../../assets/icons/mouse.svg";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import ContactSection from "../../components/ContactSection";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import student1 from "../../assets/images/student1.png";
import student2 from "../../assets/images/student2.png";
import student3 from "../../assets/images/student3.png";
import student4 from "../../assets/images/student4.png";
import Rating from "@mui/material/Rating";
import student5 from "../../assets/images/student5.png";
import ArrowRightIcon from "@mui/icons-material/ArrowRightAlt";
import GetVideos from "../../actions/GetVideos";
import { Link } from "react-router-dom";
import Box from "@mui/material/Box";

import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ModalStyle from "../../data/ModalStyle";
import Close from "@mui/icons-material/Close";
import SetPage from "../../data/SetPage";
import AlumniSection from "./AlumniSection";
import ENDPOINT from "../../data/ENDPOINT";
import axios from "axios";
import CoursesCategory from "../courses/CoursesCategory";
import UserEngagement from "./UserEngagement";
import MobileHome from "./MobileHome";
import PlacementCompanies from "./PlacementCompanies";
import SuccessStories from "./SuccessStories";
import NavbarCourseSearch from "../../components/NavbarCourseSearch";
import Gallery from "../gallery/Gallery";
import ReelsCta from "../studentpass/ReelsCta";
import { Helmet } from "react-helmet";
import SaveUserEvent from "../../actions/SaveUserEvent";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import CustomVideoPlayer from "../../components/elements/CustomVideoPlayer";
import CollegesBusinessCta from "./CollegesBusinessCta";
import { useActionsContext } from "../../context/ActionsContext";
import { VolumeUp } from "@material-ui/icons";
import HomeDesktopReviews from "./HomeDesktopReviews";
import SecurityHeaders from "../../data/SecurityHeaders";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import GroupIcon from "@mui/icons-material/Group";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import { FaStar } from "react-icons/fa";
import about1 from "../../../src/assets/about1.png";
import about2 from "../../../src/assets/about2.png";
import about3 from "../../../src/assets/about3.png";

import HackingReview from "../../components/updatehackinginternship/HackingReview";
import WhyChoseUs from "../../components/WhyChoseUs";
import Contact from "../../actions/support/Contact";
import CoursesDesign1 from "../../components/OnlineCoursesLyfax";
import Placements from "../../components/updatehackinginternship/HackingPlacements";

const HomePage = ({ account }) => {
  const [results, setresults] = useState(null);
  const [mobile, setmobile] = useState(false);
  const device = DetectDevice();
  const { user } = useContext(AuthContext);
  const { search, ShowSearch, HideSearch } = useActionsContext();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    SetPage(null);

    //  //console.log(device)
    if (device === "mobile") {
      setmobile(true);
    } else {
      setmobile(false);
    }
    NewVideos();
  }, []);

  const [scrollsuggestion, setscrollsuggestion] = useState(false);

  const [carousel, setcarousel] = useState(false);

  const [videos, setvideos] = useState(null);
  const NewVideos = async () => {
    const res = await GetVideos({ payload: { limit: 2 } });
    if (res) {
      //  //console.log("got "+JSON.stringify(res))
    }
    if (res.status === "success") {
      setvideos(res.videos);
    }
  };

  const [demo, setdemo] = useState(false);
  const style = {
    width: 500,
  };

  const [query, setquery] = useState(null);

  const [statistics, setstatistics] = useState(null);

  useEffect(() => {
    window.addEventListener("scroll", TogglePrime);
  }, []);

  const TogglePrime = () => {
    const video = document.getElementById("prime-video1");
    if (video) {
      const screenheight = window.innerHeight;
      const videoposition = parseInt(
        video.getBoundingClientRect().top.toFixed(),
      );

      if (videoposition + 200 < screenheight && videoposition > -100) {
        video.play();

        if (video.onplaying) {
          video.removeAttribute("muted");
        }
        if (video.onplaying && parseInt(video.currentTime) > 5) {
        }
      } else {
        if (video.onplaying) {
          video.pause();
        }
      }
    }
  };
  const NewOpenSearch = () => { };
  const [loginprompt, setloginprompt] = useState(false);
  const [displaysearch, setdisplaysearch] = useState(false);

  const [studentactivities, setstudentactivities] = useState(false);
  const [features, setfeatures] = useState(false);
  const [reviews, setreviews] = useState(false);

  const [muted, setmuted] = useState(true);
  // const courses = [
  //   {
  //     id: 1,
  //     title: "Wordpress Website Development",
  //     type: "SELF PACED",
  //     image:
  //       "https://upload.wikimedia.org/wikipedia/commons/2/20/WordPress_logo.svg",
  //     rating: 5,
  //     date: "31st Jan 2026",
  //     enrolled: 538,
  //     price: 1768,
  //     oldPrice: 2999,
  //     seats: "20 seats left",
  //     badgeColor: "#1e88e5",
  //   },
  //   {
  //     id: 2,
  //     title: "Human Resource Management",
  //     type: "SELF PACED",
  //     image:
  //       "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg",
  //     rating: 5,
  //     date: "31st Jan 2026",
  //     enrolled: 742,
  //     price: 1768,
  //     oldPrice: 2999,
  //     seats: "19 seats left",
  //     badgeColor: "#1e88e5",
  //   },
  //   {
  //     id: 3,
  //     title: "C language Masterclass for Students",
  //     type: "LIVE",
  //     image:
  //       "https://images.pexels.com/photos/5380642/pexels-photo-5380642.jpeg",
  //     rating: 5,
  //     date: "31st Jan 2026",
  //     enrolled: 956,
  //     price: 5799,
  //     oldPrice: 8999,
  //     seats: "7 seats left",
  //     badgeColor: "#ff3d00",
  //   },
  // ];

  const getCourses = async () => {
    console.log(getCourses);
    setLoading(true);
    try {
      const data = new FormData();
      if (device) data.append("device", device);
      const res = await axios.post(
        ENDPOINT + `get-courses.php`,
        data,
        SecurityHeaders,
      );
      console.log(res.data);

      if (res && res.data && res.data.status === "success") {
        setCourses(res.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCourses();
  }, [device]);
  //   const loadCourses = async ({payload}) => {
  //   const data = new FormData()

  //   data.append("mode",payload.mode)
  //   if(payload.limit){
  //        data.append("limit",payload.limit)
  //   }
  //   if(payload.device){

  //        data.append("device",payload.device)
  //   }
  //   const res = await
  //   axios.post(ENDPOINT+`get-courses.php`,data,SecurityHeaders)
  //   if(res){

  //        return res.data
  //   }
  // };

  //   useEffect(() => {
  //   loadCourses();
  // }, []);
  return (
    <>
      <Helmet>
        <title>
          SiliconMinds | India's Best Job guaranteed training programs
        </title>
        <meta
          name="description"
          content="SiliconMinds is India's no1 training platform with guaranteed placements | online training | offline training | pre-recorded courses | online courses | offline courses"
        />
      </Helmet>

      <div className="content home-page">
        <Modal open={demo} onClose={() => setdemo(false)}>
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Introduction</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setdemo(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                autoPlay
                src="https://skillsuprise.com/data/videos/demo.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>

        <Modal open={features} onClose={() => setfeatures(false)}>
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Features</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setfeatures(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                poster="https://skillsuprise.com/data/images/features.png"
                autoPlay
                src="https://skillsuprise.com/data/videos/features.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>

        <Modal
          open={studentactivities}
          onClose={() => setstudentactivities(false)}
        >
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Student Activities</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setstudentactivities(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                poster="https://skillsuprise.com/data/images/student-activities.png"
                autoPlay
                src="https://skillsuprise.com/data/videos/student-activities.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>

        <Modal open={reviews} onClose={() => setreviews(false)}>
          <Box
            sx={ModalStyle}
            className="col-lg-4 col-md-5 br-5 col-sm-6 col-11 p-2"
          >
            <div className="d-flex justify-content-between">
              <h4>Students Reviews</h4>
              <Close
                className="text-danger"
                type="button"
                onClick={() => setreviews(false)}
              />
            </div>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              <video
                className="w-100 bg-dark"
                controls
                poster="https://skillsuprise.com/data/images/student-reviews.png"
                autoPlay
                src="https://skillsuprise.com/data/videos/student-reviews.mp4"
              ></video>
            </Typography>
          </Box>
        </Modal>
        <section className="border-bottom">
          <div className="w-100 hero sm-pt-10 mt-2">
            <div className="container ">
              <div className="flex-wrap d-flex justify-content-between">
                <div className="col-lg-6 mx-auto mt-2">
                  <h1 className="prime-title text-dark home-title animate-fadeInUp text-center">
                    Master VLSI with Industry Ready Training from
                  </h1>
                  <h1 className="prime-description text-siliconMinds-orng animate-fadeInUp text-center ">
                    SiliconMinds Experts
                  </h1>

                  <div className="home-search animate-fadeInUp  mt-3">
                    <Paper
                      onClick={() => {
                        SaveUserEvent({
                          payload: {
                            session:
                              user != null || user != undefined
                                ? user.SessionId
                                : null,

                            page: window.location.pathname,
                            action: "HomePage-search",
                          },
                        });
                        ShowSearch();
                      }}
                      component="form"
                      sx={{
                        p: "2px 4px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <div className="d-flex w-100 align-content-center justify-content-between">
                        <p className="text-secondary m-0 p-0 d-flex align-items-center ps-1">
                          Search Courses
                        </p>
                        <IconButton
                          type="submit"
                          sx={{ p: "10px" }}
                          aria-label="search"
                        >
                          <SearchIcon />
                        </IconButton>
                      </div>
                    </Paper>
                  </div>
                  <div className="d-flex mt-2 mx-auto">
                    <div class="d-flex align-items-center"></div>


                    <div className="p-0 w-100 ">
                      {/* <div className="mt-3 d-flex justify-content-center animate-fadeInUp ">
                        <AvatarGroup>
                          <Avatar
                            alt="Remy Sharp"
                            src={student1}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Travis Howard"
                            src={student2}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Trevor Henderson"
                            src={student5}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Cindy Baker"
                            src={student3}
                            sx={{ width: 50, height: 50 }}
                          />
                          <Avatar
                            alt="Agnes Walker"
                            src={student4}
                            sx={{ width: 50, height: 50 }}
                          />
                        </AvatarGroup>
                      </div> */}
                      {/* <h5 className="mt-3 text-secondary animate-fadeInUp text-center">
                        Kick-start your career with SiliconMinds !{" "}
                      </h5> */}
                      {user != null || user != undefined ? (
                        <Link
                          onClick={() => {
                            SaveUserEvent({
                              payload: {
                                session:
                                  user != null || user != undefined
                                    ? user.SessionId
                                    : null,

                                page: window.location.pathname,
                                action: "HomePage-courses",
                              },
                            });
                          }}
                          to="/courses"
                          className="animate-fadeInUp btn d-flex align-items-center w-fit btn-siloconMinds-orng mt-4 rounded-pill sm-14 btn-sm mx-auto fw-semibold px-2"
                        >
                          BROWSE COURSES
                          <ArrowRightIcon
                            className="text-light"
                            fontSize="large"
                          />
                        </Link>
                      ) : (
                        <Link
                          onClick={() => {
                            SaveUserEvent({
                              payload: {
                                session:
                                  user != null || user != undefined
                                    ? user.SessionId
                                    : null,
                                page: window.location.pathname,
                                action: "HomePage-registerbutton",
                              },
                            });
                          }}
                          to="/signup"
                          className="mt-2 mt-md-4 animate-fadeInUp btn d-md-none d-flex align-items-center w-fit btn-siloconMinds-orng rounded-pill sm-14 btn-sm text-white mx-auto"

                        >
                          REGISTER FOR FREE
                          <ArrowRightIcon
                            className="text-white"
                            fontSize="large"
                          />
                        </Link>
                      )}
                      <div className="d-none d-lg-block ">
                        <div className="mt-2 mt-md-5 d-flex justify-content-evenly w-100 " >
                          <div className="col-6 col-md-3 mb-3 d-flex align-items-center ">
                            <GroupIcon
                              style={{ fontSize: 70 }}
                              className="me-2 icon-stats text-siliconMinds-orng ms-3"
                            />
                            <h5 className="fw-bold mt-2 text-dark stat-text me-3">
                              13000+
                              <br />
                              Students
                            </h5>
                          </div>

                          <div className="col-6 col-md-3 mb-3 d-flex align-items-center">
                            <EmojiEmotionsIcon
                              style={{ fontSize: 70, marginLeft: "20px" }}
                              className="me-2 icon-stats text-siliconMinds-orng"
                            />
                            <h5 className="fw-bold mt-2 text-dark stat-text me-3">
                              100%
                              <br />
                              Satisfied
                            </h5>
                          </div>

                          {/* <div className="col-6 col-md-3 mb-3 d-flex align-items-center stats-col mx-sm-auto">
                          <MenuBookIcon
                            style={{ fontSize: 70, marginLeft:"30px" }}
                            className="me-2 icon-stats text-siliconMinds-orng"
                          />
                          <h5 className="fw-bold mt-2 text-dark stat-text me-3">
                            10+
                            <br />
                            Courses
                          </h5>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row gx-4 gy-3 text-center text-md-start mt-2 justify-content-center stats-row d-none d-md-flex">
                  {/* <div className="col-6 col-md-3 mb-3 d-flex align-items-center stats-col">
                <RecordVoiceOverIcon style={{ fontSize: 75 }} color="primary" className="me-2 icon-stats" />
                <h5 className="fw-bold mt-2 text-dark stat-text">
                  10+<br />Instructors
                </h5>
              </div> */}
                </div>
                {/* <div className="col-lg-5 sm-mt-20 sm-mb-20 animate-fade">
                  <img src={heroimage} className="w-100" />
                </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* {device === "mobile" ? (
          <>
            <div className="mt-5">
              <MobileHome />
            </div>
          </>
        ) : (
          <div className="mt-3">
            <CoursesCategory
              offline={true}
              live={true}
              selfpaced={true}
              specialization={true}
            />
          </div>
        )} */}

        {device === "mobile" ? (
          <>
            <section>
              <CoursesDesign1 />
            </section>

            <section>
              <div className="container mt-0">
                <PlacementCompanies />
              </div>
            </section>
            <div>
              <Placements />
            </div>

            <div>
              <HackingReview />
            </div>

            <div className="mt-2 pt-2">
              <WhyChoseUs />
            </div>
            <div >
              <ContactSection />
            </div>
          </>
        ) : (
          <>
            <section>
              <CoursesDesign1 />
            </section>

            <section>
              <div className="container mt-0">
                <PlacementCompanies />
              </div>
            </section>
            <div>
              <Placements />
            </div>

            <div>
              <HackingReview />
            </div>

            <div className="mt-2 pt-2">
              <WhyChoseUs />
            </div>
            <div >
              <ContactSection />
            </div>
          </>
        )}
        {/* 
        <div
          className={device === "mobile" ? "" : "mt-0  pb-0  sm-mb-0 sm-mt-0"}
        >
          <div className="mt-5 mt-md-5 pt-0 pt-md-5">
            <Gallery limit={device === "mobile" ? 8 : 9} />
          </div>
        </div> */}
        {/* <div className="pb-0 pb-sm-5 mb-md-5 pt-0 pt-md-4 pt-lg-5 animate-fade">
          <CollegesBusinessCta />
        </div> */}
        {/* <div className="pb-5 mb-5 animate-fade">
          <ContactSection />
        </div> */}

        <style>
          {`
        .courses-wrapper{
          padding:40px 20px;
          font-family: 'Segoe UI', sans-serif;
          background:#fff;
        }
        .courses-title{
          text-align:center;
          color:#ffb300;
          font-size:38px;
          font-weight:700;
        }
        .courses-sub{
          text-align:center;
          color:#8fa2c1;
          max-width:900px;
          margin:10px auto 30px;
          font-size:17px;
        }
        .search-box{
          max-width:900px;
          margin:0 auto 40px;
          display:flex;
          gap:15px;
          align-items:center;
          flex-wrap:wrap;
          justify-content:center;
        }
        .search-box input{
          flex:1;
          min-width:250px;
          padding:14px 20px;
          border-radius:40px;
          border:2px solid #bcd1ff;
          outline:none;
          font-size:16px;
        }
        .view-btn{
          padding:14px 30px;
          border-radius:30px;
          border:1px solid #ffb300;
          background:#fff;
          color:#ffb300;
          font-weight:600;
          cursor:pointer;
          transition:all 0.3s ease;
          white-space:nowrap;
        }
        .view-btn:hover{
          background:#ffb300;
          color:#fff;
          transform:translateY(-2px);
          box-shadow:0 4px 12px rgba(255,179,0,0.3);
        }
       .cards{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
  gap:24px;
}

.card1{
  border-radius:20px;
  overflow:hidden;
  display:flex;
  flex-direction:column;
  background:#fff;
  box-shadow:0 2px 8px rgba(0,0,0,0.1);
  transition:all 0.3s ease;
}

.card1:hover{
  transform:translateY(-8px);

}

.card1 img{
  width:100%;
  height:180px;
  object-fit:cover;
}

.badge{
  position:absolute;
  top:14px;
  left:14px;
  padding:6px 14px;
  border-radius:8px;
  color:#fff;
  font-size:13px;
  font-weight:600;
}

.card-body{
  padding:16px 18px 10px;
}

.rating{
  text-align:right;
  color:#ffb300;
  font-size:16px;
  margin-bottom:6px;
}

.card-title{
  font-size:18px;
  font-weight:700;
  line-height:1.3;
  margin-bottom:10px;
  color:#222;
}

.info{
  display:flex;
  justify-content:space-between;
  align-items:center;
  font-size:14px;
  color:#9aa6bf;
  margin-bottom:8px;
}

.price-row{
  display:flex;
  justify-content:space-between;
  align-items:flex-end;
  margin-top:8px;
}

.price{
  font-size:18px;
  font-weight:700;
  color:#0a9b52;
}

.old{
  font-size:13px;
  color:#9aa6bf;
  margin-left:6px;
  text-decoration:line-through;
}

.seats{
  font-size:14px;
  font-weight:600;
  color:#ff3d00;
}

.enroll{
  margin:12px 16px 16px;
  background:linear-gradient(90deg,#ffb300,#ffca28);
  border:none;
  border-radius:14px;
  padding:12px;
  color:#fff;
  font-size:15px;
  font-weight:700;
  cursor:pointer;
  transition:all 0.3s ease;
}

.enroll:hover{
  transform:scale(1.02);
  box-shadow:0 4px 12px rgba(255,179,0,0.4);
}

@media(max-width:768px){
  .search-box{
    flex-direction:column;
    gap:10px;
  }
  .search-box input{
    width:100%;
    min-width:unset;
  }
  .view-btn{
    width:100%;
  }
  .courses-title{
    font-size:28px;
  }
  .courses-sub{
    font-size:15px;
  }
  .cards{
    grid-template-columns:1fr;
    gap:16px;
  }
}
        `}
        </style>
      </div>
    </>
  );
};

export default HomePage;
